package com.essntl.core.whatsapp.data.response

import com.essntl.features.message.domain.model.WhapiChatModel
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class WhapiChatDto(
    val id: String,
    val timestamp: Int,
    @SerialName("unread")
    val unreadCount: Int? = null,
    @SerialName("last_message")
    val lastMessage: WhapiMessageDto? = null,
    val name: String? = null,
    val type: String,
    val source: String? = null,
    val participants: List<GroupParticipantDto>? = null,
) {
    fun toModel(): WhapiChatModel =
        WhapiChatModel(
            id = id,
            timestamp = timestamp,
            unreadCount = unreadCount,
            lastMessage = lastMessage?.toModel(),
            name = name,
            phoneNumber = getContactPhoneNumber,
            type = when (type) {
                "contact" -> WhapiChatModel.ChatType.Contact
                "group" -> WhapiChatModel.ChatType.Group
                else -> WhapiChatModel.ChatType.Unknown
            },
            source = source,
            participants = participants?.map { it.toModel() },
        )

    private val getContactPhoneNumber: String
        get() =
            id.split("@").firstOrNull() ?: ""

}
